//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {serverURL} from "@/config";

export default {
  name: "Login",
  data() {
    return {
      email: '',
      password: '',
      showDialog: false,
      loading: false
    }
  },
  methods: {
    login() {
      this.loading = true
      this.$http.post(`${ serverURL }/wp-json/jwt-auth/v1/token`, {
        "username": this.email,
        "password": this.password
      }).then((response) => {
        this.$store.dispatch("updateJwtToken", response.data.token)
        this.loading = false
        this.$router.push( { name: 'posts' })
      })
          .catch((error) => {
            this.message = error
            this.showSnackbar = true;
            this.password = '';
            this.loading = false
          })
    }
  }
}
